import { useTranslation } from 'react-i18next';
import { Brand } from '@src/components/Brand/Brand';
import { Button } from '@src/components/Button/Button';
import { Typography } from '@src/components/Typography/Typography';
import { mainSiteUrl } from './boxDomainNavigation';
import './BoxDomainUnavailable.css';

/** Independent of game data: an unknown hostname has no theme or permissions. */
export function BoxDomainUnavailable({
  missing,
  onRetry,
}: {
  missing: boolean;
  onRetry: () => void;
}) {
  const { t } = useTranslation();
  return (
    <main className="domain-unavailable" data-testid="game-domain-unavailable">
      <Brand href={mainSiteUrl('/')}>{t('brand.name')}</Brand>
      <section
        className="domain-unavailable__panel"
        role="alert"
        aria-labelledby="domain-unavailable-title"
      >
        <p className="domain-unavailable__code">
          {missing ? '404' : t('boxDomainUnavailable.temporary')}
        </p>
        <h1 id="domain-unavailable-title">
          {t(`boxDomainUnavailable.${missing ? 'title' : 'errorTitle'}`)}
        </h1>
        <p>{t(`boxDomainUnavailable.${missing ? 'hint' : 'errorHint'}`)}</p>
        <div className="domain-unavailable__actions">
          {!missing && <Button onClick={onRetry}>{t('boxDomainUnavailable.retry')}</Button>}
          <a
            className={`button button--${missing ? 'primary' : 'secondary'} button--medium`}
            href={mainSiteUrl('/')}
          >
            <Typography as="span" role="label/button-md" color="inherit" className="button__label">
              {t('boxDomainUnavailable.home')}
            </Typography>
          </a>
        </div>
      </section>
    </main>
  );
}
